<template>
  <div>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
        <div class="content-header row"></div>
        <div class="content-body">
          <!-- login page start -->
          <section id="auth-login" class="row flexbox-container">
            <div class="col-xl-8 col-11">
              <div class="card bg-authentication mb-0">
                <div class="row m-0">
                  <!-- left section-login -->
                  <div class="col-md-6 col-12 px-0">
                    <div
                      class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center"
                    >
                      <div class="card-header pb-1">
                        <div class="text-center">
                          <h2>
                            <img
                              src="@/app-assets/images/brand/pacto-logo.png"
                              alt="Pacto Logo"
                              style="width: 160px"
                            />
                          </h2>
                        </div>
                      </div>
                      <div class="card-content">
                        <div class="card-body">
                          <div class="divider">
                            <div class="divider-text text-uppercase text-muted">
                              <small>Reset your password</small>
                            </div>
                          </div>
                          <div class="text-center" v-if="loginError !== ''">
                            <p class="error" :innerHTML="loginError"></p>
                          </div>
                          <form
                            action="#"
                            :class="{ 'form-group--error': v$.password.$error }"
                          >
                            <div class="form-group">
                              <label class="text-bold-600" for="passwordInput"
                                >New Password</label
                              >
                              <input
                                type="password"
                                class="form-control"
                                id="passwordInput"
                                placeholder="Password"
                                v-model.trim="v$.password.$model"
                              />
                              <small
                                >You must keep your password secret. It is HIGHLY recommended that your password is unique to the Pacto platform. You should follow your organizations guidance on Passwords and refrain from using any password that you use with your organization's internal platforms and services. </small
                              >
                            </div>
                            <button
                              @click="resetPassword()"
                              :disabled="v$.$invalid"
                              type="button"
                              class="btn btn-primary glow w-100 position-relative"
                              v-if="!loggingIn"
                            >
                              Reset Password<em
                                id="icon-arrow"
                                class="bx bx-right-arrow-alt"
                              ></em>
                            </button>
                            <button
                              disabled
                              type="button"
                              class="btn btn-primary glow w-100 position-relative"
                              v-else
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span class="sr-only">Loading...</span>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- right section image -->
                  <div
                    class="col-md-6 d-md-block d-none text-center align-self-center p-3"
                  >
                    <div class="card-content">
                      <lottie-player
                        src="https://assets4.lottiefiles.com/packages/lf20_fwykef3x.json"
                        background="transparent"
                        speed="1"
                        style="width: 100%; height: auto"
                        loop
                        autoplay
                      ></lottie-player>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- login page ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/css/pages/authentication.css";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators';
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      password: "",
      loggingIn: false,
      submitStatus: false,
      loginError: "",
    };
  },

  methods: {
    async resetPassword() {
      const code = this.$route.query.oobCode;

      this.v$.$touch();
      this.submitStatus = true;

      try {
        this.loggingIn = true;
        this.loginError = "";

        await this.$apiCall.post(`/v1/auth/change/password`, {
          oobCode: code,
          newPassword: this.password,
        });

        location.href = "/login";
      } catch (error) {
        this.loginError =
          error.response.data.message === "Error with user ops: "
            ? "<strong>Ops!</strong> Invalid Token"
            : error.response.data.message;
        this.loggingIn = false;
        this.v$.password.$model = "";
      }
    },
  },

  mounted() {
    $("body").removeClass(
      "vertical-layout vertical-menu-modern 2-columns navbar-sticky footer-static"
    );
    $("body").addClass(
      "vertical-layout vertical-menu-modern 1-column navbar-sticky footer-static bg-full-screen-image blank-page blank-page"
    );
  },

  beforeMount() {
    const code = this.$route.query.oobCode;

    if (!code) {
      location.href = "/";
    }
  },

  validations: {
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.error {
  color: red;
}
</style>
